<button
	class="flex flex-col gap-1 rounded-lg transition-all duration-150 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus'"
	(click)="toggle($event)"
	(keydown)="onKeyDown($event)"
	[tabindex]="disabled() ? -1 : tabindex()"
	[class.cursor-not-allowed]="disabled()"
	[class.cursor-pointer]="!disabled()"
>
	<div
		class="border border-solid h-4 relative rounded-xl w-9 transition-colors duration-150 ease-in-out"
		[class.bg-secondary-300]="!checked() && !disabled()"
		[class.border-secondary-900]="!checked() && !disabled()"
		[class.bg-secondary-100]="!checked() && disabled()"
		[class.border-secondary-400]="!checked() && disabled()"
		[class.bg-primary-300]="checked() && !disabled() && color() === UIThemes.Primary"
		[class.border-primary-700]="checked() && !disabled() && color() === UIThemes.Primary"
		[class.bg-primary-100]="checked() && disabled() && color() === UIThemes.Primary"
		[class.border-primary-400]="checked() && disabled() && color() === UIThemes.Primary"
		[class.bg-[var(--color-plan-primary-300)]]="
			checked() && !disabled() && color() === UIThemes.Blue
		"
		[class.border-[var(--color-plan-primary-700)]]="
			checked() && !disabled() && color() === UIThemes.Blue
		"
		[class.bg-[var(--color-plan-primary-100)]]="
			checked() && disabled() && color() === UIThemes.Blue
		"
		[class.border-[var(--color-plan-primary-400)]]="
			checked() && disabled() && color() === UIThemes.Blue
		"
	>
		<div
			class="rounded-50 size-5 absolute transition-all duration-150 ease-in-out top-[calc(50%-0.625rem)]"
			[class.left-thumb-inactive]="!checked()"
			[class.left-4]="checked()"
			[class.bg-secondary-900]="!checked() && !disabled()"
			[class.bg-secondary-400]="!checked() && disabled()"
			[class.bg-primary-700]="checked() && !disabled() && color() === UIThemes.Primary"
			[class.bg-primary-400]="checked() && disabled() && color() === UIThemes.Primary"
			[class.bg-[var(--color-plan-primary-700)]]="
				checked() && !disabled() && color() === UIThemes.Blue
			"
			[class.bg-[var(--color-plan-primary-400)]]="
				checked() && disabled() && color() === UIThemes.Blue
			"
		></div>
	</div>
</button>
